import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Quick create — the "חדש" actions of the top bar (Alt+1..) open a screen with ?new=1;
 * the screen opens its own create dialog (same form, same server call) and the flag is dropped from the URL.
 */
export const QUICK_CREATE_PARAM = 'new';

export function useQuickCreate(open, { ready = true } = {}) {
  const [params, setParams] = useSearchParams();
  const openRef = useRef(open);
  openRef.current = open;
  const flag = params.get(QUICK_CREATE_PARAM);
  useEffect(() => {
    if (!flag || !ready) return;
    const next = new URLSearchParams(params);
    next.delete(QUICK_CREATE_PARAM);
    setParams(next, { replace: true });
    openRef.current?.();
  }, [flag, ready]); // eslint-disable-line react-hooks/exhaustive-deps
}
